export{AspectRatio,ImageComponent,ImageOrientation,ObjectFit}from"./image.component.js";
//# sourceMappingURL=index.js.map
